import React from "react";
import clsx from "clsx";
import { Link, useStaticQuery, graphql } from "gatsby";
import { MdLanguage } from "react-icons/md";
import {
  FaTwitterSquare,
  FaGithubSquare,
  FaFacebookSquare,
  FaLinkedin,
  FaYoutubeSquare,
  FaRssSquare,
} from "react-icons/fa";

import SMCLogo from "./SMCLogo";
import relocalizeUrl from "./utils/relocalizeUrl";

import styles from "./Footer.module.css";
import commonStyles from "./common.module.css";
import languages from "../app/intl/languages";

const Footer = ({ currentURL, langKey = "it" }) => {
  const {
    allFooterLinksYaml: { edges: categories },
  } = useStaticQuery(graphql`
    {
      allFooterLinksYaml {
        edges {
          node {
            category
            label {
              ...Translations
            }
            links {
              url
              label {
                ...Translations
              }
            }
          }
        }
      }
    }
  `);

  return (
    <footer className={styles.footer}>
      <div className={commonStyles.container}>
        <div className={styles.columnsContainer}>
          <div className={styles.column}>
            <SMCLogo className={styles.logo} width={190} height={51} />

            <ul className={clsx(styles.list, styles.firstColumn)}>
              {Object.entries(languages).map(([id, lang]) => (
                <li key={id}>
                  <Link
                    to={
                      currentURL ? relocalizeUrl(currentURL, id) : lang.baseUrl
                    }
                  >
                    <MdLanguage />
                    {lang.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {categories.map(({ node: { category, label, links } }) => (
            <div key={category} className={styles.column}>
              <h2>{label[langKey]}</h2>
              <ul className={styles.list}>
                {links.map(({ url, label }) => (
                  <li key={url}>
                    <a href={url}>{label[langKey]}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <hr className={styles.horizDivider} />

        <div className={styles.lastLine}>
          <div className={commonStyles.grow}>
            © {new Date().getFullYear()}, Copyright{" "}
            <a href="https://www.smc.it">SMC Treviso</a>
          </div>
          <div>
            <a
              className={styles.socialIcon}
              href="https://twitter.com/SMCPartner/"
            >
              <FaTwitterSquare size="1.5em" />
            </a>
            <a className={styles.socialIcon} href="https://github.com/smclab/">
              <FaGithubSquare size="1.5em" />
            </a>
            <a
              className={styles.socialIcon}
              href="https://www.linkedin.com/company/smc-azienda-informatica/"
            >
              <FaLinkedin size="1.5em" />
            </a>
            <a
              className={styles.socialIcon}
              href="https://www.facebook.com/GRUPPOSMC/"
            >
              <FaFacebookSquare size="1.5em" />
            </a>
            <a
              className={styles.socialIcon}
              href="https://www.youtube.com/user/GRUPPOSMC/"
            >
              <FaYoutubeSquare size="1.5em" />
            </a>
            <a className={styles.socialIcon} href="/rss.xml">
              <FaRssSquare size="1.5em" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
